import { RenderEditCellProps } from "@bst/react-data-grid";
import { ProjectThresholdDTO } from "../../../apiclients/bstinsights";
import { useIMask } from "react-imask";
import { useEffect } from "react";
import { MODAL_CLOSE_BTN_ID } from '../../HyperFocus/utils/constants';

type Props = {
  cancelChanges?: () => void;
  showOverrideError?: () => void;
  updateNLMOverride: (row: ProjectThresholdDTO) => void;
} & RenderEditCellProps<ProjectThresholdDTO>;

export const NLMValueInputCell = ({
  row,
  cancelChanges,
  showOverrideError,
  updateNLMOverride,
}: Props) => {
  const { ref } = useIMask<HTMLInputElement>(
    {
      mask: Number,
      min: -999.99,
      max: 999.99,
      scale: 2,
      radix: ".",
      thousandsSeparator: "",
      normalizeZeros: true,
      padFractionalZeros: true,
    }
  );

  useEffect(() => {
    // Auto-focus on mount
    ref?.current?.focus();
    ref?.current?.select();
  }, [ref]);

  return (
    <input
      className="project-override-input"
      data-testid="project-override-input"
      ref={ref}
      style={{ textAlign: "end" }}
      disabled={row.projectId === -1}
      defaultValue={row.nlmThreshold}
      onBlur={(event) => {
        // If input value is empty
        if (!event.target.value.length) {
          // If close modal button clicked cancel changes and close modal
          if (event.relatedTarget?.id === MODAL_CLOSE_BTN_ID) {
            cancelChanges?.()
            return;
          }
          // Else show error modal
          showOverrideError?.()
          return
        }
        updateNLMOverride?.({ ...row, nlmThreshold: Number(event.target.value) });
      }}
      onKeyDown={(event) => {
        const blurInput = event.key === 'Enter' || event.key === 'Escape'
        if (blurInput) {
          if (!event.currentTarget.value.length) {
            showOverrideError?.()
            return
          }
          updateNLMOverride?.({ ...row, nlmThreshold: Number(event.currentTarget.value) });
        }
      }}
    />
  );
};
